import { createApiInstance } from './handler';
import { generateLeadershipReportJson } from '../utils/leadership-report-json-generator';

export const getFeedbackReportId = async (auth, target, isDevelop) => {
  try {
    const targetReport = generateLeadershipReportJson(target, isDevelop);
    const response = await createApiInstance(auth, 'client').post('/feedback-report', targetReport);
    if (response.data) {
      return response.data.request_id;
    }
  } catch (error) {
    console.error('Error fetching feedback report ID:', error);
    throw error;
  }
};

export const getFeedbackReport = async (auth, feedbackReportId) => {
  try {
    const response = await createApiInstance(auth, 'client').get(`/feedback-report/${feedbackReportId}`);
    if (response.data?.exists && response.data?.ai_response) {
      return response.data.ai_response;
    }

    const maxAttempts = 90; // 3 minutes / 2 seconds
    const interval = 2000;

    for (let attempt = 0; attempt < maxAttempts; attempt++) {
      const response = await createApiInstance(auth, 'client').get(`/feedback-report/${feedbackReportId}`);

      if (response.data?.exists && response.data?.ai_response) {
        return response.data.ai_response;
      }

      if (attempt < maxAttempts - 1) {
        await new Promise((resolve) => setTimeout(resolve, interval));
      }
    }
  } catch (error) {
    console.error('Error fetching feedback report:', error);
    throw error;
  }
};
